import { render } from "./Suggest.vue?vue&type=template&id=afc84a2a&scoped=true"
import script from "./Suggest.vue?vue&type=script&lang=ts"
export * from "./Suggest.vue?vue&type=script&lang=ts"

import "./Suggest.vue?vue&type=style&index=0&id=afc84a2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-afc84a2a"

export default script